import { useState, useEffect } from 'react';
import { getAllData, getSnapshotUpdatedAt, forceRefresh, refreshSnapshot } from '../qlik';

export function useQlikData() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [lastUpdated, setLastUpdated] = useState(null);

  // mode: 'cache' (läs cachad snapshot) | 'reread' (läs om cachen) | 'force' (admin: live Qlik)
  const loadData = async (mode = 'cache') => {
    setLoading(true);
    try {
      if (mode === 'force')       await forceRefresh();
      else if (mode === 'reread') await refreshSnapshot();
      const result = await getAllData();
      setData({
        monthly: result.monthly,
        ytd: result.ytd,
        daily: result.daily || [],
        bookings: result.bookings || null,
        newBookings: result.newBookings || null,
      });
      setLastUpdated(getSnapshotUpdatedAt() || new Date());
      setError(null);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
    const iv = setInterval(() => loadData('reread'), 15 * 60 * 1000);
    return () => clearInterval(iv);
  }, []);

  return { data, loading, error, lastUpdated, refresh: loadData };
}
